import localforage from 'localforage';
class Storage {
    constructor(idg) {
        this.id = idg.appid;
        this.storage = localforage.createInstance({
            name: this.id,
        });
    }
    getItem(key) {
        return this.storage.getItem(key);
    }
    setItem(key, value) {
        return this.storage.setItem(key, value);
    }
    removeItem(key) {
        return this.storage.removeItem(key);
    }
    clear() {
        return this.storage.clear();
    }
    destroy() {
        localforage.dropInstance({
            name: this.id,
        });
    }
}
export default Storage;
